export const LEGACY_SF_PAGE_LISTENERS = {
  selectors: {
    highlightsAndRecords: [{ element: 'windowViewMode-normal oneContent active lafPageHost', attribute: 'class', childLocation: 0 }],
  },
  indicatorIterations: {
    numOfIterations: 20,
    millisPerIteration: 1000,
  },
  observers: {
    recordDetailsComponent: [{ element: 'windowViewMode-normal oneContent active lafPageHost', attribute: 'class', childLocation: 0 }],
    findComponentValue: [{ element: 'force_detailPanel', attribute: 'data-component-id' }],
  },
  indicators: {
    salesforceClassicIndicator: [{ element: 'contactHeaderRow', attribute: 'id' }],
    salesforceLightningIndicators: {
      pageView: [{ element: 'windowViewMode-normal oneContent active lafPageHost', attribute: 'class', childLocation: 0 }, { element: 'slds-page-header__row', attribute: 'class', childLocation: 0 }, { element: 'oneRecordHomeFlexipage2Wrapper', attribute: 'class', childLocation: 0 }],
      forceHighlightsPanel_QuerySelector: '.slds-page-header__title',
    },
  },
};
